// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3G0ia","title":"AfterFrontImage_title__3wSH2"};